<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style1', { sticky: isSticky }]">
      <div class="header-top">
        <div class="container">
          <TopHeader />
        </div>
      </div>
      <MainNavbarPages />
    </div>

    <div class="content-wrapper">
      <!-- <PageBanner pageTitle="Service Details" mainTitle="Service Details" /> -->
      <div class="service-details-wrap ptb-50">
        <div class="container">
          <div class="row">
            <div class="col-xl-4 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
              <SideBar />
            </div>

            <div class="col-xl-8 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
              <div class="service-desc">
                <!-- <img src="../../../assets/images/service/endocrinologie-1.jpeg" alt="Endocrinologie" /> -->

                <h2>Endocrinologie – echilibrul hormonal, esențial pentru sănătatea ta</h2>
                <p>
                  Endocrinologia se ocupă cu diagnosticarea și tratarea afecțiunilor
                  sistemului endocrin, responsabile de echilibrul hormonal al organismului.
                  Consultațiile sunt orientate către identificarea cauzelor și stabilirea
                  unui plan terapeutic personalizat.
                </p>


                <!-- <h2>Echipa medicală</h2> -->
                <div class="row">
                  <div class="col-xl-3 col-lg-4 col-md-6 aos-init aos-animate" data-aos="fade-up"
                    data-aos-duration="1200" data-aos-delay="500">
                    <a href="/echipa_medicala/gina_neculaes#echipa_medicala">
                      <div class="team-card style1">
                        <div class="team-img"><img src="../../../assets/images/doctors/dr-gina-neculaes-1.jpg"
                            alt="dr-gina-neculaes"></div>
                        <div class="team-info">
                          <span>Dr. Gina Neculăeș</span> 
                          <!-- <span>Medic specialist endocrinolog</span> -->
                        </div>
                      </div>
                    </a>
                  </div>
                </div>


                <h3>Servicii</h3>
                <p>
                  În cadrul cabinetului de endocrinologie sunt oferite evaluări complete
                  pentru principalele afecțiuni ale sistemului endocrin.
                </p>


                <div class="card mb-10" v-for="service in services" :key="service.name">
                  <div class="row" style="padding: 10px 20px;">
                    <div class="card-service col-xl-10 col-lg-10 col-md-10">
                      <i class="ri-check-double-line" style="vertical-align: bottom;"></i> {{ service.name }}
                    </div>
                    <div class="service-price col-xl-2 col-lg-2 col-md-2 text-align-right">
                      <!-- {{ service.price }} Lei -->
                    </div>
                  </div>
                </div>

                <div class="other-option md-none mb-40">
                  <a href="/#appointment" class="btn style2">
                    Solicită o programare
                  </a>
                </div>

                <h3>Întrebări frecvente</h3>
                <p>
                  Mai jos găsești răspunsuri la cele mai frecvente întrebări legate de
                  consultațiile endocrinologice.
                </p>

                <div class="accordion" id="accordionExample_one">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Când este recomandată o consultație endocrinologică?
                      </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Consultația endocrinologică este recomandată în cazul tulburărilor
                          hormonale, problemelor tiroidiene, variațiilor neexplicate de greutate,
                          oboselii persistente sau modificărilor metabolice.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Este necesară trimitere pentru consultație?
                      </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Pentru consultațiile în cadrul clinicii private, nu este necesară
                          trimitere medicală. Programarea se poate face direct.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Ce analize sunt necesare înainte de consultație?
                      </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Medicul va recomanda analizele necesare în funcție de simptomele
                          și istoricul medical. Analizele pot fi efectuate înainte sau după
                          consultație, conform indicațiilor primite.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingFour">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        <span>
                          <i class="ri-add-line plus"></i>
                          <i class="ri-subtract-line minus"></i>
                        </span>
                        Pot veni la consultație pentru un control preventiv?
                      </button>
                    </h2>
                    <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample_one">
                      <div class="accordion-body">
                        <p>
                          Da, consultația endocrinologică este recomandată și în scop
                          preventiv, pentru evaluarea echilibrului hormonal și depistarea
                          timpurie a eventualelor dezechilibre.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>


    </div>
    <MainFooter />
  </div>
</template>

<script>
import TopHeader from "../../Layouts/TopHeader.vue";
import MainNavbarPages from "../../Layouts/MainNavbarPages.vue";
import SideBar from "./SideBar.vue";
// import ServiceDetails from "../../ServiceDetails/ServiceDetails.vue";
import MainFooter from "../../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "EndocrinologiePage",
  components: {
    TopHeader,
    SideBar,
    MainNavbarPages,
    // ServiceDetails,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
      services: [
        {
          name: "Consultație endocrinologică",
          price: 300
        },
        {
          name: "Evaluarea și monitorizarea afecțiunilor tiroidei",
          price: 200
        },
        {
          name: "Interpretare analize hormonale",
          price: 350
        },
        {
          name: "Stabilirea și ajustarea tratamentului",
          price: 200
        }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    });
  },
});
</script>